import SubscriptionDirectPayment from './SubscriptionDirectPayment';

export default SubscriptionDirectPayment;
